import { useNavigate, useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import useEventCallback from '@unifyapps/hooks/useEventCallback';

export const useRouter = () => {
  const navigate = useNavigate();
  const pathname = useLocation().pathname;
  const search = useLocation().search;
  const getState = useEventCallback(() => ({
    pathname,
    searchParams: new URLSearchParams(search),
  }));

  return useMemo(
    () => ({
      push: (path: string, useNativeRouter: boolean = false) => {
        if (useNativeRouter) {
          return window.location.assign(path);
        }
        navigate(path);
      },
      replace: (path: string, useNativeRouter: boolean = false) => {
        if (useNativeRouter) {
          return window.location.replace(path);
        }

        navigate(path, { replace: true });
      },
      back: () => {
        navigate(-1);
      },
      searchParams: new URLSearchParams(search),
      pathname,
      getState,
    }),
    [pathname, search],
  );
};
